import React from 'react'

function BigProfessionalDevelopmentIcon() {
  return (
    <svg
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M120 60.0089C120 93.1483 93.1306 120 59.9911 120C26.8517 120 0 93.1306 0 60.0089C0 26.8871 26.8694 0
            60.0089 0C93.1483 0 120.018 26.8694 120.018 60.0089H120Z"
        className="fill"
        fill="#4A4A4A"
        fillRule="nonzero"
      />
      <path
        transform="scale(2.4,2.4)"
        fill="#FFFFFF"
        d="M25,30.74a3.81,3.81,0,1,0-3.8-3.8A3.8,3.8,0,0,0,25,30.74Z"
      />
      <rect
        transform="scale(2.4,2.4)"
        fill="#FFFFFF"
        x="17.27"
        y="41.95"
        width="1.65"
        height="1.55"
      />
      <path
        transform="scale(2.4,2.4)"
        fill="#FFFFFF"
        d="M21.32,23H17.53v1.56h2.64A5.18,5.18,0,0,1,21.32,23Z"
      />
      <path
        transform="scale(2.4,2.4)"
        fill="#FFFFFF"
        d="M35.09,28.87,32.16,21a1.56,1.56,0,0,0-2.89,1.16l2.44,6-3.9,3.86-5.2.95c-1,0-2,.87-2.72,1.31l-1.84,1.1,
            1.11-3a1.32,1.32,0,0,0-.73-1.79,1.62,1.62,0,0,0-1.95.78l-2.85,7.72,1.69,1.53,5.16-2.23V49.59A25.84,25.84,0,
            0,0,25,50a25.37,25.37,0,0,0,4.73-.45c0-6.74,0-12.69,0-12.7Z"
      />
      <path
        transform="scale(2.4,2.4)"
        fill="#FFFFFF"
        d="M15,30.92l0-.06,0-.06a2.87,2.87,0,0,1,.82-1v-28a23.93,23.93,0,0,0-3.11,1.47V37Z"
      />
      <path
        transform="scale(2.4,2.4)"
        fill="#FFFFFF"
        d="M15,42.52l-.74-.67-1.5-1.35v6.31a23.93,23.93,0,0,0,3.11,1.47V42.14Z"
      />
      <path
        transform="scale(2.4,2.4)"
        fill="#FFFFFF"
        d="M17.53,4.11V5.67H33.11v7.9H17.53v1.56H33.11v4.51a3.19,3.19,0,0,1,.49.82h0v0l2.61,7V2.66a25.85,25.85,0,0,
            0-3.11-1.31V4.11Z"
      />
      <path
        transform="scale(2.4,2.4)"
        fill="#FFFFFF"
        d="M35.34,31.28,33.85,33.5l-.37.55-.37.55V42H31.28v1.56h1.83v5.14a24.33,24.33,0,0,0,3.11-1.31V30Z"
      />
    </svg>
  )
}

export default BigProfessionalDevelopmentIcon
